import React from "react";
import Navbar from "@/components/Navbar";

export default function Terms() {
    return (
        <div className="min-h-screen bg-ink text-slate-900">
            <Navbar />
            <main className="max-w-3xl mx-auto px-6 lg:px-10 py-16">
                <div className="mono-label mb-3">/ LEGAL</div>
                <h1 className="font-display text-4xl md:text-5xl tracking-tighter mb-6" data-testid="terms-title">
                    Términos de Servicio
                </h1>

                <div className="border border-amber-300 bg-amber-50 text-amber-800 text-sm rounded-sm p-4 mb-10">
                    <strong>Revisado por un abogado — pendiente de datos de la empresa.</strong> El contenido
                    de este documento ya ha sido revisado y aprobado. Antes de publicarlo, falta rellenar los
                    datos reales de la entidad titular del Servicio en el punto 2 (razón social, domicilio y
                    número de registro — NRT en Andorra o CIF/NIF en España).
                </div>

                <div className="prose prose-slate max-w-none text-sm leading-relaxed space-y-6 text-slate-700">
                    <p className="text-xs text-slate-400">Última actualización: [fecha]</p>

                    <section>
                        <h2 className="font-display text-xl text-slate-900 mb-2">1. Aceptación de los términos</h2>
                        <p>Al crear una cuenta o usar Vivoz ("el Servicio"), aceptas estos Términos de
                        Servicio y la Política de Privacidad en su totalidad. Si no estás de acuerdo, no debes
                        usar el Servicio. Para dejar constancia expresa de tu consentimiento (exigido por el
                        artículo 10 de la Llei 20/2014 andorrana y por el RGPD para el tratamiento de datos
                        que conlleva usar la app), la aplicación te pedirá aceptar estos términos la primera
                        vez que inicies sesión, y de nuevo si se publica una versión con cambios materiales.</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl text-slate-900 mb-2">2. Identificación del prestador</h2>
                        <p>Vivoz es prestado por [razón social pendiente de confirmar], con domicilio en
                        [dirección pendiente] y número de registro [NRT/CIF pendiente]. Correo de contacto:
                        info@vivoz.es. Esta información es obligatoria bajo el artículo 10 de la Ley 34/2002
                        (LSSI-CE) española y su equivalente andorrano (Llei 20/2014) — rellénala con los datos
                        reales de la sociedad antes de operar comercialmente.</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl text-slate-900 mb-2">3. Descripción del servicio</h2>
                        <p>Vivoz es una plataforma de entrenamiento de oratoria asistida por inteligencia
                        artificial. Durante las sesiones de práctica, el Servicio puede acceder a tu cámara
                        y micrófono, procesar tu voz mediante transcripción automática, y generar feedback
                        conversacional usando modelos de IA de terceros (OpenAI).</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl text-slate-900 mb-2">4. Cuentas de usuario</h2>
                        <p>Debes tener al menos 16 años para crear una cuenta. Eres responsable de mantener
                        la confidencialidad de tu contraseña y de toda actividad realizada desde tu cuenta.
                        Debes proporcionar información veraz al registrarte. (Nota: la LOPDGDD española permite
                        el consentimiento digital a partir de los 14 años en determinados casos; mantenemos
                        16 como umbral único y más protector para simplificar el cumplimiento en ambas
                        jurisdicciones — confírmalo con tu asesor legal si quieres ajustarlo.)</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl text-slate-900 mb-2">5. Suscripciones y pagos</h2>
                        <p>Los planes de pago (Basic, Pro, Studio) se cobran de forma recurrente mensual a
                        través de Stripe. Puedes cancelar tu suscripción en cualquier momento desde
                        Ajustes → Facturación; la cancelación surte efecto al final del periodo ya pagado,
                        sin reembolsos parciales salvo que la ley aplicable exija lo contrario. Las "fichas"
                        no tienen valor monetario fuera del Servicio y no son transferibles.</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl text-slate-900 mb-2">6. Derecho de desistimiento (usuarios en España)</h2>
                        <p>Si contratas un plan de pago como consumidor residente en España, el artículo 102
                        del Real Decreto Legislativo 1/2007 te reconoce un plazo de 14 días naturales para
                        desistir del contrato sin justificar el motivo. Ahora bien, al tratarse de contenido y
                        servicios digitales que empiezan a prestarse de inmediato (acceso inmediato a fichas y
                        sesiones de práctica), este derecho se pierde en cuanto la ejecución del servicio
                        comienza con tu consentimiento expreso previo y tu reconocimiento de que perderás el
                        derecho de desistimiento (artículo 103.m TRLGDCU). El formulario de alta te pedirá
                        esta confirmación de forma expresa antes de procesar el primer pago.</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl text-slate-900 mb-2">7. Contenido generado por IA</h2>
                        <p>El feedback, puntuaciones y consejos generados por el Servicio se producen mediante
                        modelos de lenguaje y pueden contener errores o imprecisiones. No constituyen
                        asesoramiento profesional (legal, médico, psicológico o de otro tipo) y no deben
                        tratarse como tal.</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl text-slate-900 mb-2">8. Clasificación y datos públicos</h2>
                        <p>Si participas en la clasificación (leaderboard), tu nombre y tu puntuación pueden
                        mostrarse públicamente a otros usuarios del Servicio.</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl text-slate-900 mb-2">9. Cuentas de equipo (plan Studio)</h2>
                        <p>Si te unes a un equipo Studio como cuenta invitada, el propietario del equipo
                        podrá ver estadísticas agregadas de tu actividad (puntuación media, número de
                        sesiones) a través del panel de administración.</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl text-slate-900 mb-2">10. Uso aceptable</h2>
                        <p>No debes usar el Servicio para generar contenido ilegal, acosar a terceros,
                        intentar vulnerar la seguridad de la plataforma, ni automatizar el acceso mediante
                        bots o scraping sin autorización.</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl text-slate-900 mb-2">11. Limitación de responsabilidad</h2>
                        <p>El Servicio se ofrece "tal cual". En la medida permitida por la ley, no
                        garantizamos disponibilidad ininterrumpida ni resultados específicos de mejora en
                        tus habilidades de oratoria, y no seremos responsables de daños indirectos derivados
                        del uso del Servicio. Nada en esta cláusula limita derechos irrenunciables reconocidos
                        a los consumidores por el TRLGDCU español o el Codi de Consum andorrano.</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl text-slate-900 mb-2">12. Ley aplicable y jurisdicción</h2>
                        <p>Estos términos se rigen por la legislación de Andorra, sin perjuicio de las
                        disposiciones imperativas de protección al consumidor que la legislación española
                        reconozca a los usuarios residentes en España, que se aplicarán con preferencia
                        cuando corresponda. Para cualquier controversia, las partes se someterán a los
                        tribunales del domicilio del consumidor cuando este resida en España o Andorra, salvo
                        que la normativa aplicable disponga otro fuero de forma imperativa.</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl text-slate-900 mb-2">13. Cambios en los términos</h2>
                        <p>Podemos actualizar estos términos ocasionalmente. Te notificaremos de cambios
                        materiales por email o mediante un aviso en la aplicación, y te pediremos que los
                        aceptes de nuevo la próxima vez que inicies sesión.</p>
                    </section>

                    <section>
                        <h2 className="font-display text-xl text-slate-900 mb-2">14. Contacto</h2>
                        <p>Para cualquier duda sobre estos términos, escribe a{" "}
                        <a href="mailto:info@vivoz.es" className="text-brand hover:underline">info@vivoz.es</a>.</p>
                    </section>
                </div>
            </main>
        </div>
    );
}
